import {
  DefaultButton,
  DetailsList,
  DetailsListLayoutMode,
  IColumn,
  Label,
  Layer,
  MessageBar,
  MessageBarType,
  Panel,
  PanelType,
  SelectionMode,
  Spinner,
  ThemeProvider,
} from '@fluentui/react';
import dateformat from 'dateformat';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { getAsync } from '../../../../utils/api';
import { theme } from '../../../../utils/theme';
import { commaNumber } from '../../../NumberField';

export default (formId: string) =>
  new Promise((resolve) => {
    const div = document.createElement("div");
    document.body.append(div);

    const closeModal = () => {
      ReactDOM.unmountComponentAtNode(div);
      div.remove();
      resolve(true);
    };
    const Component = () => {
      const [items, setItems] = useState<any[]>([]);

      useEffect(() => {
        getAsync(`/forms/get-history?id=${formId}`).then(({ data }) => {
          setItems(data);
        });
      }, []);

      return (
        <Layer>
          <Panel
            isOpen
            isLightDismiss
            type={PanelType.large}
            styles={{ main: { maxWidth: "unset !important" } }}
            onDismiss={closeModal}
          >
            <ThemeProvider theme={theme}>
              <div style={{ width: "100%" }}>
                {items.length > 0 ? (
                  <DetailsList
                    items={items}
                    selectionMode={SelectionMode.none}
                    layoutMode={DetailsListLayoutMode.fixedColumns}
                    columns={columns}
                  />
                ) : (
                  <Spinner />
                )}
              </div>
            </ThemeProvider>
          </Panel>
        </Layer>
      );
    };

    ReactDOM.render(<Component />, div);
  });

const ViewPDFButton = ({
  formId,
  version,
}: {
  formId: string;
  version: string;
}) => {
  const [loading, setLoading] = useState(false);

  if (loading) {
    return <Spinner />;
  } else {
    return (
      <DefaultButton
        text="PDF"
        iconProps={{ iconName: "PDF" }}
        onClick={async () => {
          setLoading(true);

          const pdf = await getAsync(
            `/forms/get-pdf?id=${encodeURIComponent(
              formId
            )}&versionId=${encodeURIComponent(version)}`
          );
          const url = URL.createObjectURL(pdf);

          setLoading(false);
          window.open(url);
        }}
      />
    );
  }
};
const columns: IColumn[] = [
  {
    key: "version",
    name: "Version",
    minWidth: 16,
    flexGrow: 0.5,
    onRender: (item) => <Label>{item?.version}</Label>,
  },
  {
    key: "description",
    name: "Aciklama",
    minWidth: 16,
    flexGrow: 1,
    onRender: (item) => item?.account?.displayName,
  },
  {
    key: "employee",
    name: "Temsilci",
    minWidth: 16,
    flexGrow: 1,
    onRender: (item) => item?.employee?.name,
  },
  {
    key: "employee",
    name: "Düzenleme",
    minWidth: 16,
    flexGrow: 1,
    onRender: (item) => dateformat(new Date(item?.created), "dd.mm.yyyy HH:MM"),
  },
  {
    key: "remaining-balance",
    name: "Kalan Bakiye",
    minWidth: 16,
    flexGrow: 1,
    onRender: (item) =>
      item?.summary?.unpaidTotal ? (
        <MessageBar messageBarType={MessageBarType.warning}>
          {commaNumber(item?.summary?.unpaidTotal)} TL
        </MessageBar>
      ) : (
        <span>-</span>
      ),
  },
  {
    key: "actions",
    name: "Eylemler",
    minWidth: 16,
    flexGrow: 0.5,
    onRender: (item) => (
      <ViewPDFButton
        formId={item?.formId || ""}
        version={item?.version || ""}
      />
    ),
  },
];
